import React, { Component } from 'react';
import { ImageBackground, Platform, Dimensions } from 'react-native';
import OPComponent from '../components/op_component';

import regularBg from '../../../resources/auth_bg/bg-login.jpg';
import militaryBg from '../../../resources/auth_bg/bg-login-military.jpg';

export default class BackgroundImageContainer extends OPComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // read dimensions to set on ImageBackground to fix issue in android where a white pixel shows on the right
    let backgroundImageStyles = [
      {
        flex: 1,
        paddingBottom: 10,
        justifyContent: 'center',
      },
    ];
    if (Platform.OS === 'android') {
      let { height, width } = Dimensions.get('window');
      backgroundImageStyles.push({ width: width + 1, height: height });
    }

    const source = this.props.isMilitary ? militaryBg : regularBg;

    return (
      <ImageBackground source={source} style={backgroundImageStyles}>
        {this.props.children}
      </ImageBackground>
    );
  }
}
